import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createEmptyBoardEditBoardState } from './boardEdit.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerBoardEdit = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return createEmptyBoardEditBoardState()
  return (
    state.taskTracker.boardEdit.byBoardId[boardId] ??
    createEmptyBoardEditBoardState()
  )
}
